import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { getCardDate } from '~/views/dashboard/whats-new-widget/components/card-base/utils';

import * as S from './StreamCard.styles';

export enum CardType {
  CompanyCatalyst,
  MarketCatalyst,
  MarketSummary,
  Scenario,
  EarningsPreview,
  EarningsRecap,
}

export interface StreamCardProps {
  className?: string;
  headerContent: ReactNode;
  cardTitle: ReactNode;
  description: ReactNode;
  leftNode?: ReactNode;
  isRead?: boolean;
  onClick?: () => void;
  date?: Date;
}

export const StreamCard = ({
  className,
  headerContent,
  cardTitle,
  description,
  leftNode,
  isRead = false,
  onClick,
  date,
}: StreamCardProps) => {
  const { t } = useTranslation(['whatsNew', 'insights']);
  const cardDate = date ?? new Date();

  return (
    <S.Root
      className={className}
      $isHighlighted={false}
      $isRead={isRead}
      onClick={onClick}
    >
      <S.FlexWrapper>
        {leftNode}
        <S.Content>
          <S.HeaderWrapper $isRead={isRead}>{headerContent}</S.HeaderWrapper>
          {cardTitle}
          <S.FooterWrapper>
            <S.Description>{description}</S.Description>
            <S.DateLabel>{getCardDate(cardDate, t)}</S.DateLabel>
          </S.FooterWrapper>
        </S.Content>
      </S.FlexWrapper>
    </S.Root>
  );
};
